import { React } from "react";
import {Link} from 'react-router-dom'

import './Header2.scss'

const Header = () => {

    return (
        <div className="headerr">
            <Link className="logoo" to="/"></Link>
            {/* <div>Hi</div> */}
        </div>
    );
}

export default Header;
